// extracted by mini-css-extract-plugin
export var contentGrid = "_q-3";
export var divider = "_q-t";
export var emailInput = "_q-8";
export var emptyDescription = "_q-z";
export var emptyState = "_q-x";
export var emptyTitle = "_q-y";
export var fadeIn = "_q-10";
export var formCard = "_q-5";
export var formGroup = "_q-7";
export var helperText = "_q-9";
export var imagePlaceholder = "_q-n";
export var itemDetails = "_q-l";
export var itemImage = "_q-m";
export var itemInfo = "_q-p";
export var itemName = "_q-q";
export var itemPrice = "_q-s";
export var itemQuantity = "_q-r";
export var itemsList = "_q-j";
export var mainContent = "_q-4";
export var orderItem = "_q-k";
export var orderSummaryCard = "_q-i";
export var pageContainer = "_q-0";
export var pageHeader = "_q-1";
export var pageTitle = "_q-2";
export var paymentDescription = "_q-e";
export var paymentIcon = "_q-b";
export var paymentInfo = "_q-a";
export var paymentMethods = "_q-f";
export var paymentText = "_q-d";
export var placeholderText = "_q-o";
export var sectionTitle = "_q-6";
export var sidebarContent = "_q-h";
export var stripeIcon = "_q-c";
export var submitButton = "_q-g";
export var totalAmount = "_q-w";
export var totalLabel = "_q-v";
export var totalRow = "_q-u";